// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends ApiService {

  brand(slug: string): Promise<any>  {
    return this.get(`/v1/partner/${slug}/brand/`).toPromise();
  }

  detail(apiKey: string): Promise<any>  {
    return this.get(`/v2/partners/${apiKey}/details`).toPromise();
  }
}
